import http from './index'

export default {
  // 获取首页配置信息
  list (params) {
    return http.get('/front/userWidget/', params)
  }
}
